import { Icon, Menu, MenuItem } from 'semantic-ui-react';
import { useEffect, useState } from 'react';
import { TeamsDetails } from "./TeamsDetails";
import { TeamHistoryList } from "./TeamHistoryList";
import { TeamScheduler } from './TeamSchedule';

export const TeamWrapper = (props) => {

    const [chosenElement, setChosenElement] = useState(props.chosenElement ? props.chosenElement : "View")
    const [pageArgs, setPageArgs] = useState({})

    function changePage(page, args) {
        setChosenElement(page)
        setPageArgs(args)
    }

    useEffect(() => {
        window.history.replaceState(null, "", chosenElement.toLowerCase())
    }, [chosenElement])

    return (
        <>
            <div align="center" style={{ paddingBottom: "2rem" }}>
                <div style={{ width: "fit-content" }}>
                    <Menu pointing>
                        <MenuItem content={<><Icon color="grey" className="list" />Details</>} name="View"
                            onClick={() => setChosenElement('View')} active={chosenElement === 'View'} />
                        <MenuItem content={<><Icon color="grey" className="history" />Changelog</>} name="Changelog"
                            onClick={() => setChosenElement('Changelog')} active={chosenElement === 'Changelog'} />
                        <MenuItem content={<><Icon color="grey" className="calendar" />Calendar</>} name="Calendar"
                            onClick={() => setChosenElement('Calendar')} active={chosenElement === 'Calendar'} />
                    </Menu>
                </div>
            </div>

            {chosenElement === 'View' && <TeamsDetails changePage={changePage} {...pageArgs} />}
            {chosenElement === 'Changelog' && <TeamHistoryList changePage={changePage} {...pageArgs} />}
            {chosenElement === 'Calendar' && <TeamScheduler changePage={changePage} {...pageArgs} />}
        </>
    );

}
